import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToBmpConfig } from '@/data/landingConfig/landingImageToBmpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToBmp } from './schemaObject';

interface Props {}
const ImageToBmpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToBmp} />
			<LandingTemplate
				data={landingImageToBmpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default ImageToBmpConverter;
